import { AUTH_API_URL } from "../utils/constants";

export const OAUTH_PAGE_PATH = '/oauth'
// export const redirectUrl = window.location.origin + OAUTH_PAGE_PATH;
export const redirectUrl =  window.location.origin + '/' + window.CONFIG.REACT_APP_CONTEXT_PATH + OAUTH_PAGE_PATH;
export const oAuthCodeUrl = `${AUTH_API_URL}/authorize?response_type=code&client_id=${window.CONFIG.CLIENT_ID}&redirect_uri=${redirectUrl}&scope=all`;

export const HOME_PAGE_PATH = '/portal-smm-ws-notary-frontend/' ;

export const routePath = Object.freeze({
  HOME: '/',
  NEW_REQUEST:'/new-request',
  VERIFICATION:'/verification',
  REQUEST_LIST:'/request-list',
  REQUEST_DETAILS:'/request-details',
  DIGITAL_FRONT: '/portal-digital-frontend',
  AUTH: '/oauth'
});
